import React, { createContext, useState, useContext, useEffect } from 'react';
import { jwtDecode } from "jwt-decode"; // 修正: 名前付きインポート
import { getMe } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 起動時にローカルストレージのトークンを確認
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    let decoded = null;
    try {
      decoded = jwtDecode(token);
    } catch (e) {
      localStorage.removeItem('token');
      setLoading(false);
      return;
    }
    if (!(decoded.exp * 1000 > Date.now())) {
      localStorage.removeItem('token');
      setLoading(false);
      return;
    }
    // まずトークンの中身で表示を始める。
    setUser({ email: decoded.sub, role: decoded.role });
    // **役割は allowed_users の行を正とする。** トークンはアクセスのたびに
    // 再発行されるので、役割を変えたときにログインし直さずに効くようにする
    // (2026-10-26: 調査担当と主任担当者を役割で分けたため)。
    getMe()
      .then((me) => { if (me && me.email) setUser({ email: me.email, role: me.role }); })
      .catch(() => { /* 取れなくてもトークンの中身で続ける */ })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);